import type { EditorState } from '../store/editorState';

const getContextMenuOrigin = (state: EditorState) => state.contextMenu?.origin;
const isOpen = (state: EditorState) => Boolean(state.contextMenu);

export { getContextMenuOrigin, isOpen };
